import { render } from "./DashboardList.vue?vue&type=template&id=1c9d540f&scoped=true"
import script from "./DashboardList.vue?vue&type=script&lang=js"
export * from "./DashboardList.vue?vue&type=script&lang=js"

import "./DashboardList.vue?vue&type=style&index=0&id=1c9d540f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9d540f"]])

export default __exports__